import React, { useEffect } from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import { FaPhone, FaEnvelope } from 'react-icons/fa';
import { COLORS } from '../constants/colors';

function ShippingInfoScreen() {
    const copper = COLORS.COPPER;
    const sageGreen = COLORS.SAGE_GREEN;
    const plum = COLORS.PLUM;
    
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="bg-light min-vh-100 py-5">
            <Container>
                {/* Hero Section */}
                <Row className="mb-5">
                    <Col className="text-center">
                        <h1 className="display-4 fw-bold mb-3" style={{ color: plum }}>
                            International Shipping
                        </h1>
                        <p className="lead" style={{ color: copper }}>
                            Professional shipping services for your pigeons
                        </p>
                    </Col>
                </Row>

                {/* Kaladokwe Quarantine Centre Section */}
                <Row className="mb-5">
                    <Col className="text-center">
                        <h2 className="h3 fw-bold mb-4" style={{ color: plum }}>
                            Kaladokwe Quarantine Centre
                        </h2>
                    </Col>
                </Row>

                <Row className="mb-5">
                    <Col md={6}>
                        <div className="bg-white p-4 rounded-3 shadow-sm">
                            <h3 className="h4 mb-4" style={{ color: plum }}>When Dreams Come True</h3>
                            <p className="text-muted mb-4">
                                In the heart of the Karoo in a small town Cradock situated in the EASTERN CAPE SOUTH AFRICA, 
                                the dream of one person became a reality to promote the love and passion for the pigeon sport. 
                                Approved by state authorities, this project a huge success, We proudly introduce KALADOKWE QUARANTINE CENTRE.
                            </p>
                            <p className="text-muted mb-4">
                                The mastermind and founder of KQC MR IVAN STOCK may stand flamboyant and broad-chested, 
                                this is just the beginning of great things from which so many pigeon fanatics can benefit.
                            </p>
                            <p className="text-muted mb-4">
                                KQC specialise in the import and export of pigeons. Thus making it possible for fanciers 
                                to effortlessly import and export their pigeons to various destinations around the globe.
                            </p>
                            <p className="text-muted mb-4">
                                KALADOKWE QUARANTINE CENTRE boasts with their own panel of veterinarians. Famously known 
                                for his expertise and reputable reputation in the field of veterinary Dr Gavin Rous, 
                                trained under his supervision and guidance, Dr Monica Muller, she is also part of our team.
                            </p>
                            <p className="text-muted mb-4">
                                We are currently an accredited recruiting agent and shipping agent for Vic Falls, and PIPR 
                                (Pattaya International Pigeon Race) will henceforth act accordingly. Service excellence is 
                                of utmost importance to us, and we will strive to uphold a favorable reputation.
                            </p>
                            <p className="text-muted mb-4">
                                We look forward to possible prosperous business relationships and affiliations with clubs 
                                and OLR's alike.
                            </p>
                            <p className="text-muted fst-italic mb-4">
                                "Your Journey.. Our Mission"...
                            </p>
                            <p className="text-muted mb-0">
                                KALADOKWE QUARANTINE CENTRE<br />
                                MISS MARLETTE KLEINHANS
                            </p>
                        </div>
                    </Col>
                    <Col md={6}>
                        <div className="bg-white p-4 rounded-3 shadow-sm">
                            <h3 className="h4 mb-4" style={{ color: plum }}>Contact Information</h3>
                            <div className="d-flex align-items-center mb-3">
                                <FaPhone className="me-2" style={{ color: sageGreen }} />
                                <div>
                                    <p className="mb-1"><a href="tel:+27832737504" className="text-decoration-none text-dark">+27 83 273 7504</a></p>
                                    <p className="mb-0"><a href="tel:+27781589345" className="text-decoration-none text-dark">+27 78 158 9345</a></p>
                                </div>
                            </div>
                            <div className="d-flex align-items-center mb-4">
                                <FaEnvelope className="me-2" style={{ color: sageGreen }} />
                                <a href="mailto:kaladokwe.qua@gmail.com" className="text-decoration-none text-dark">kaladokwe.qua@gmail.com</a>
                            </div>

                            <div className="row g-3">
                                <div className="col-6">
                                    <Image 
                                        src="/images/image1.jpeg" 
                                        alt="Quarantine Station" 
                                        fluid 
                                        className="rounded-3 shadow-sm"
                                    />
                                </div>
                                <div className="col-6">
                                    <Image 
                                        src="/images/image2.jpeg" 
                                        alt="Monitoring System" 
                                        fluid 
                                        className="rounded-3 shadow-sm"
                                    />
                                </div>
                                <div className="col-4">
                                    <Image 
                                        src="/images/image3.jpeg" 
                                        alt="Facility" 
                                        fluid 
                                        className="rounded-3 shadow-sm"
                                    />
                                </div>
                                <div className="col-4">
                                    <Image 
                                        src="/images/image4.jpeg" 
                                        alt="Staff" 
                                        fluid 
                                        className="rounded-3 shadow-sm"
                                    />
                                </div>
                                <div className="col-4">
                                    <Image 
                                        src="/images/image5.jpeg" 
                                        alt="Equipment" 
                                        fluid 
                                        className="rounded-3 shadow-sm"
                                    />
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>

            </Container>
        </div>
    );
}

export default ShippingInfoScreen; 